export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_27-3a30d81d89815db27eabd6091e710956.jpg";